import { $fetch } from '@/boot/fetch'

const ENDPOINT = '/auth'

export default {
  /**
   * Send user a link to sign in via email
   * @param {Object} data
   * @param {String} data.email - Email address
   * @param {String} data.path - Path to redirect user to after sign in
   * @returns {Promise}
   */
  async sendEmailSignInLink({ email, path }) {
    return $fetch.peg(`${ENDPOINT}/sendSignInLinkToEmail`, {
      method: 'POST',
      body: { emailAddress: email, path },
    })
  },
  /**
   * Update user's email address
   * @param {Object} data
   * @param {String} data.email - New email address
   * @returns {Promise}
   */
  async updateUserEmail(newEmail) {
    return $fetch.peg(`${ENDPOINT}/updateUserEmail`, {
      method: 'PUT',
      body: { newEmail },
    })
  },
  /**
   * Recover user's email address
   * @param {Object} data
   * @param {String} data.email - Email address
   * @returns {Promise}
   */
  async recoverUserEmail(originalEmail, token) {
    return $fetch.peg(`${ENDPOINT}/recoverUserEmail`, {
      method: 'PUT',
      body: { originalEmail },
      headers: { 'x-recovery-token': token },
    })
  },

  /**
   * Send a one-time password (OTP) to the user's email
   * @param {string} email - Email address to send the OTP to
   * @returns {Promise}
   */
  sendEmailOTP(email) {
    return $fetch.peg(`${ENDPOINT}/sendEmailOTP`, {
      method: 'POST',
      body: { email },
    })
  },
  /**
   * Verify the email OTP
   * @param {string} email - Email address to verify
   * @param {string} code - OTP code to verify
   * @returns {Promise}
   */
  verifyEmailOTP(email, otp) {
    return $fetch.peg(`${ENDPOINT}/verifyEmailOTP`, {
      method: 'PUT',
      body: { email, otp },
    })
  },
  completePhoneAuth(email) {
    return $fetch
      .peg(`${ENDPOINT}/completePhoneAuth`, {
        method: 'PUT',
        body: { email },
      })
      .then(res => {
        // set new user flag on 201 status code
        return { ...res, isNewUser: res.statusCode === 201 }
      })
  },
  /**
   * Request a phone OTP for logged in user
   * @returns {Promise}
   */
  sendPhoneOTP(phone) {
    return $fetch.peg(`${ENDPOINT}/sendPhoneOTP`, {
      raw: true,
      method: 'POST',
      body: { phone },
    })
  },
  /**
   * Verify a phone OTP for the logged in user
   * @param {string} otp - OTP to verify
   * @returns {Promise}
   */
  verifyPhoneOTP(phone, otp) {
    return $fetch.peg(`${ENDPOINT}/verifyPhoneOTP`, {
      raw: true,
      method: 'PUT',
      body: { phone, otp },
    })
  },
}
